import Auth from '@aws-amplify/auth';
import Cache from '@aws-amplify/cache';

export default {
  getHeaderAuthorization: async () => {
    const federatedInfo = Cache.getItem('federatedInfo');

    if (federatedInfo) {
      return {
        authorization: federatedInfo.token,
        provider: federatedInfo.provider,
      };
    }

    const { idToken } = (await Auth.currentSession()) || { idToken: {} };

    return {
      provider: 'CognitoUserPool',
      authorization: idToken.jwtToken,
    };
  },

  promiseGetHeaderAuthorization: () => {
    return new Promise((resolve, reject) => {
      const federatedInfo = Cache.getItem('federatedInfo');
      if (federatedInfo)
        return resolve({
          provider: federatedInfo.provider,
          authorization: federatedInfo.token,
        });
      return Auth.currentSession()
        .then(({ idToken }) => {
          let token = null;
          if (idToken) token = idToken.jwtToken;
          return resolve({
            provider: 'CognitoUserPool',
            authorization: token,
          });
        })
        .catch((er) => {
          return reject(er);
        });
    });
  },
};
